import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
  
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: '首页',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: '首页',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '阳光教育官网'
          }
        },
        {
          path: '/admin',
          name: '管理系统',
          component: resolve => require(['@/view/admin'], resolve),
        },
        {
          path: '/summarySunshine',
          name: '阳光概括',
          component: resolve => require(['@/view/SummarySunshine'], resolve),
          meta: {
            title: '阳光概括'
          }
        },
        
        {
          path: '/productCenter/domesticStudy',
          name: '阳光研学-国内线路',
          component: resolve => require(['@/view/productCenter/DomesticStudy'], resolve),
          meta: {
            title: '阳光研学-国内线路'
          }
        },
        {
          path: '/productCenter/internationalStudy',
          name: '阳光研学-国外线路',
          component: resolve => require(['@/view/productCenter/InternationalStudy'], resolve),
          meta: {
            title: '阳光研学-国外线路'
          }
        },
        {
          path: '/productCenter/studyAll',
          name: '研学内容',
          component: resolve => require(['@/view/productCenter/StudyAll'], resolve),
        },
        {
          path: '/productCenter/lineDetail',
          name: '研学详情',
          component: resolve => require(['@/view/productCenter/LineDetail'], resolve),
          meta: {
            title: '研学详情'
          }
        },
        {
          path: '/productCenter/activitiyDetail',
          name: '综合实践详情',
          component: resolve => require(['@/view/productCenter/ActivitiyDetail'], resolve),
          meta: {
            title: '综合实践详情'
          }
        },
        {
          path: '/productCenter/ComprehensivePractice',
          name: '综合实践',
          component: resolve => require(['@/view/productCenter/ComprehensivePractice'], resolve),
          meta: {
            title: '综合实践'
          }
        },
        {
          path: '/productCenter/activitiesAll',
          name: '综合实践内容',
          component: resolve => require(['@/view/productCenter/ActivitiesAll'], resolve),
          meta: {
            title: '综合实践'
          }
        },
        {
          path: '/productCenter/physicalEducation',
          name: '体教融合',
          component: resolve => require(['@/view/productCenter/PhysicalEducation'], resolve),
          meta: {
            title: '体教融合'
          }
        },
        {
          path: '/productCenter/studyStandards',
          name: '阳光研学标准',
          component: resolve => require(['@/view/productCenter/StudyStandards'], resolve),
          meta: {
            title: '阳光研学标准'
          }
        },
        {
          path: '/productCenter/exploration',
          name: '北京模式探索',
          component: resolve => require(['@/view/productCenter/Exploration'], resolve),
          meta: {
            title: '北京模式探索'
          }
        },
        {
          path: '/productCenter/research',
          name: '课题研究',
          component: resolve => require(['@/view/productCenter/Research'], resolve),
          meta: {
            title: '课题研究'
          }
        },
        {
          path: '/productCenter/teacherTrain',
          name: '教师培训',
          component: resolve => require(['@/view/productCenter/TeacherTrain'], resolve),
          meta: {
            title: '教师培训'
          }
        },
        {
          path: '/productCenter/artCompetition',
          name: '艺考培训&赛事集训',
          component: resolve => require(['@/view/productCenter/ArtCompetition'], resolve),
          meta: {
            title: '艺考培训&赛事集训'
          }
        },
        {
          path: '/productCenter/talent',
          name: '背景提升&指尖人才培养',
          component: resolve => require(['@/view/productCenter/Talent'], resolve),
          meta: {
            title: '背景提升&指尖人才培养'
          }
        },
        {
          path: '/productCenter/studyPlan',
          name: '升学规划',
          component: resolve => require(['@/view/productCenter/StudyPlan'], resolve),
          meta: {
            title: '升学规划'
          }
        },
        {
          path: '/productCenter/curriculumSystem',
          name: '课程体系',
          component: resolve => require(['@/view/productCenter/CurriculumSystem'], resolve),
          meta: {
            title: '课程体系'
          }
        },
        {
          path: '/productCenter/innovativeTalents',
          name: '拔尖人才',
          component: resolve => require(['@/view/productCenter/InnovativeTalents'], resolve),
          meta: {
            title: '拔尖人才'
          }
        },
        // {
        //   path: '/productCenter',
        //   name: 'productCenter',
        //   // component: resolve => require(['@/view/productCenter'], resolve),
        //   meta: {
        //     title: '产品中心'
        //   },
        //   children: [
        //     {
        //       path: '/domesticStudy',
        //       redirect: '/domesticStudy/DomesticStudy'
        //     },
        //     // {
        //     //   path: '/software/smartTown',
        //     //   name: 'software',
        //     //   component: resolve => require(['@/view/Software_smartTown'], resolve),
        //     //   meta: {
        //     //     title: '软件产品丨智能小镇管理系统'
        //     //   }
        //     // },
        //     // {
        //     //   path: '/software/bigData',
        //     //   name: 'software',
        //     //   component: resolve => require(['@/view/Software_bigData'], resolve),
        //     //   meta: {
        //     //     title: '软件产品丨大数据管理系统'
        //     //   }
        //     // }
        //   ]
        // },
        {
          path: '/hotNew',
          name: 'hotNew',
          component: resolve => require(['@/view/HotNew'], resolve),
          meta: {
            title: '热点资讯'
          }
        }, {
          path: '/service',
          name: '公司介绍',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/downloadCenter',
          name: '下载中心',
          component: resolve => require(['@/view/DownloadCenter'], resolve),
          meta: {
            title: '下载中心'
          }
        },
        {
          path: '/hotNewDetail',
          name: '热点资讯',
          component: resolve => require(['@/view/HotNewDetail'],resolve),
          meta: {
            title: '热点资讯'
          }
        }
      ]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js